var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardRegFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 24.5H14C12.067 24.5 10.5 26.067 10.5 28V84C10.5 85.933 12.067 87.5 14 87.5H98C99.933 87.5 101.5 85.933 101.5 84V28C101.5 26.067 99.933 24.5 98 24.5Z",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 73.5H59.5",
    stroke: "#EE7A00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 73.5H31.5",
    stroke: "#EE7A00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4976 42.3729H101.498",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1949 5.18754C17.6592 3.49747 15.0442 3.37232 13.3542 4.90801C11.6641 6.44369 11.5389 9.05868 13.0746 10.7487L100.363 106.813C101.899 108.503 104.514 108.628 106.204 107.092C107.894 105.556 108.019 102.941 106.484 101.251L19.1949 5.18754Z",
    fill: "#EE7A00",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardRegFail);
export default __webpack_public_path__ + "static/media/card-reg_fail.e0a5e0802036f499d9ca292e0bf4d60f.svg";
export { ForwardRef as ReactComponent };